import React from "react";
import { useNavigate } from "react-router";

function HomeScreenPopularPDFTools() {
  //react router navigate
  const navigate = useNavigate(); //react router navigate

  return (
    <div className="container text-center">
      {/* Title */}
      <div style={{ marginTop: "6rem" }}>
        <label className="display-6 fw-bold text-dark">
          Your Favourite PDF Tools
        </label>
      </div>

      <div className=" mt-2">
        <label className="fs-6">
          Free pdf tools. No Download. Edit Online/Offline.
        </label>
      </div>

      {/* Popular Tools grid */}
      <div className="mt-5">
        {/* Tools grid */}
        <div className="row">
          {/* PDF Compressor */}
          <div
            className="col-md-3 mt-1"
            style={{ cursor: "pointer" }}
            onClick={() => {
              //navigate
              navigate("/compress_pdf", {
                state: { title: "Compress PDF files" },
              }); //Navigate to new route
            }}
          >
            <div className="card border-0" style={{ height: "130px" }}>
              <div className="card-body bg-light">
                <div className="d-flex justify-content-between">
                  <h5 className="fw-bold fs-6">Compress PDF</h5>
                  <img
                    loading="lazy"
                    style={{ width: "10px", height: "16px" }}
                    src="./images/arrow_right.png"
                    alt=""
                  />
                </div>
                <p className="card-text text-muted text-start fs-7 mt-2">
                  Reduce size of PDF without loosing quality.
                </p>
              </div>
            </div>
          </div>

          {/* PDF Merger */}
          <div
            className="col-md-3 mt-1"
            style={{ cursor: "pointer" }}
            onClick={() => {
              //navigate
              navigate("/merge_pdf", { state: { title: "Merge PDF files" } }); //Navigate to new route}}
            }}
          >
            <div className="card border-0" style={{ height: "130px" }}>
              <div className="card-body bg-light">
                <div className="d-flex justify-content-between">
                  <h5 className="fw-bold fs-6">Merge PDF</h5>
                  <img
                    style={{ width: "10px", height: "16px" }}
                    src="./images/arrow_right.png"
                    alt=""
                  />
                </div>
                <p className="card-text text-muted text-start fs-7 mt-2">
                  Combine two or more PDFs into one unified document.
                </p>
              </div>
            </div>
          </div>

          {/* PDF Splitter */}
          <div
            className="col-md-3 mt-1"
            style={{ cursor: "pointer" }}
            onClick={() => {
              //navigate
              navigate("/split_pdf", {
                state: { title: "Split PDF in parts" },
              }); //Navigate to new route}}
            }}
          >
            <div className="card border-0" style={{ height: "130px" }}>
              <div className="card-body bg-light">
                <div className="d-flex justify-content-between">
                  <h5 className="fw-bold fs-6">Split PDF</h5>
                  <img
                    loading="lazy"
                    style={{ width: "10px", height: "16px" }}
                    src="./images/arrow_right.png"
                    alt=""
                  />
                </div>
                <p className="card-text text-muted text-start fs-7 mt-2">
                  Split a PDF into two or more documents.
                </p>
              </div>
            </div>
          </div>

          {/* PDF to JPG */}
          <div
            className="col-md-3 mt-1"
            style={{ cursor: "pointer" }}
            onClick={() => {
              //navigate
              navigate("/pdf_to_image", {
                state: { title: "PDF to Image Converter" },
              }); //Navigate to new route}}
            }}
          >
            <div className="card border-0" style={{ height: "130px" }}>
              <div className="card-body bg-light">
                <div className="d-flex justify-content-between">
                  <h5 className="fw-bold fs-6">PDF to JPG</h5>
                  <img
                    loading="lazy"
                    style={{ width: "10px", height: "16px" }}
                    src="./images/arrow_right.png"
                    alt=""
                  />
                </div>
                <p className="card-text text-muted text-start fs-7 mt-2">
                  Export PDF pages as .jpg, .png etc.
                </p>
              </div>
            </div>
          </div>

          <div className="row mt-1">
            {/* JPG to PDF */}
            <div
              className="col-md-3 mt-1"
              style={{ cursor: "pointer" }}
              onClick={() => {
                //navigate
                navigate("/image_to_pdf", {
                  state: { title: "JPG to PDF Converter" },
                }); //Navigate to new route}}
              }}
            >
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">JPG to PDF</h5>
                    <img
                      loading="lazy"
                      style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png"
                      alt=""
                    />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Convert any .jpg, .png, .bmp, .gif images to PDF document.
                  </p>
                </div>
              </div>
            </div>

            {/* Watermark PDF */}
            <div
              className="col-md-3 mt-1"
              style={{ cursor: "pointer" }}
              onClick={() => {
                //navigate
                navigate("/watermark_pdf", {
                  state: { title: "Watermark PDF documents" },
                }); //Navigate to new route}}
              }}
            >
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">Watermark PDF</h5>
                    <img
                      loading="lazy"
                      style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png"
                      alt=""
                    />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Add watermarks to PDF documents and protect your IP.
                  </p>
                </div>
              </div>
            </div>

            {/* Lock PDF */}
            <div
              className="col-md-3 mt-1"
              style={{ cursor: "pointer" }}
              onClick={() => {
                //navigate
                navigate("/lock_pdf", {
                  state: { title: "Change PDF password, Lock PDF" },
                }); //Navigate to new route}}
              }}
            >
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">Lock PDF</h5>
                    <img
                      loading="lazy"
                      style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png"
                      alt=""
                    />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Password protect your PDF document file.
                  </p>
                </div>
              </div>
            </div>

            {/* Unlock PDF */}
            <div
              className="col-md-3 mt-1"
              style={{ cursor: "pointer" }}
              onClick={() => {
                //navigate
                navigate("/unlock_pdf", {
                  state: { title: "Unlock PDF files" },
                }); //Navigate to new route
              }}
            >
              <div className="card border-0" style={{ height: "130px" }}>
                <div className="card-body bg-light">
                  <div className="d-flex justify-content-between">
                    <h5 className="fw-bold fs-6">Unlock PDF</h5>
                    <img
                      loading="lazy"
                      style={{ width: "10px", height: "16px" }}
                      src="./images/arrow_right.png"
                      alt=""
                    />
                  </div>
                  <p className="card-text text-muted text-start fs-7 mt-2">
                    Remove password from any PDF document.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeScreenPopularPDFTools;
